import { useCallback } from 'react';
import type { ActionHandlerType, OnActionArgs } from '../../../../context/ActionsProvider/context';
import {
  type GlobalStateStoreFlows,
  useGetGlobalStateStoreStateByInstanceId,
} from '../../../../stores/GlobalStateStore';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

function useImportObjects() {
  const { getNoCodeComputedData } = useGetNoCodeComputedData();
  const getGlobalStateStoreState = useGetGlobalStateStoreStateByInstanceId();

  const importObjects: ActionHandlerType = useCallback(
    ({ action, actionContext, instanceId }: OnActionArgs) => {
      const { actions } = getGlobalStateStoreState(instanceId);
      const payload = action.payload as GlobalStateStoreFlows['importObjectRecords'];
      const computedPayload = getNoCodeComputedData<GlobalStateStoreFlows['importObjectRecords']>(
        payload ?? {},
        actionContext,
      );

      if (payload?.objectId) {
        return new Promise<boolean>((resolve, reject) => {
          actions.setPreBuiltFlow({
            type: 'importObjectRecords',
            data: {
              ...computedPayload,
              onSuccess: () => resolve(SHOULD_NOT_PROPAGATE_UP),
              onClose: () => resolve(SHOULD_NOT_PROPAGATE_UP),
              onError: () => reject(SHOULD_NOT_PROPAGATE_UP),
            },
          });
        });
      }
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [getNoCodeComputedData, getGlobalStateStoreState],
  );

  return { importObjects };
}

export default useImportObjects;
